import {OverlayContainer} from "../../../misc/ImageViewer";
import Settings from "../../../settings/Settings";
import React, {useState} from "react";
import SchemaEditContainer from "../SchemaEditContainer";
import {SqlQuery} from "../BackTableFieldViewTable";
import {useAppDispatch, useAppSelector} from "../../../../hooks";
import {schemas} from "../../../../config";
import {setBackTableJoin} from "../../../../features/schemaManageSlice";


type PropsI = {
    closeEditing: () => void,
    joinKey: string,
    join: string,
    addNew?: boolean
};
export default function EditJoin({closeEditing, join, joinKey, addNew = false}: PropsI) {

    const tableName = useAppSelector(state => state.schemaManage.back.selectedTable) as string;
    const table = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    let deps = Object.entries(table.fieldsList).filter(([key, field]) =>
        !!(field.joinDependencies && field.joinDependencies.includes(joinKey)))

    const [newValue, setNewValue] = useState(join)
    const [name, setName] = useState(joinKey)

    const dispatch = useAppDispatch();


    const deletable = deps.length > 0;
    return <OverlayContainer $isVisible>
        <SchemaEditContainer>
            <div>{addNew ? "Створити" :"Редагувати"} джоїн {name}</div>
            {addNew && <div>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)}/>
            </div>}
            <div><SqlQuery sqlQuery={join}/></div>
            <div>Нове значення:</div>
            <div className="new-text-area">
                <textarea name="newJoin" id="newJoin" rows={4} value={newValue}
                          onChange={(e) => setNewValue(e.target.value)}></textarea>
            </div>
            <div>Поля що залежать:</div>
            <div className="join-deps">
                {deps.map(([k, f]) => <div className="dep" key={k}>
                    {k}
                </div>)}
            </div>
            {!addNew && <div className="delete-join">
                <button className={'btn-cmn'} disabled={deletable} onClick={() => {
                    dispatch(setBackTableJoin({
                        table: tableName,
                        joinKey: joinKey,
                        value: undefined
                    }))
                    closeEditing()
                }}>Видалити цей джоїн
                </button>
                {deletable && <div className="cant-delete">
                    Не можна видалити джоїн поки є залежні поля
                </div>}
            </div>}
            <div className={'controls'}>
                <button className={'save btn-cmn'} onClick={() => {
                    if (addNew && ethereal && ethereal.joins[name]) {
                        alert("Джоїн з таким ключем вже є! Змініть ключ")
                        return
                    }
                    dispatch(setBackTableJoin({
                        table: tableName,
                        joinKey: name,
                        value: newValue
                    }))
                    closeEditing()
                }}>
                    Зберегти
                </button>
                <button className="close btn-cmn" onClick={closeEditing}>
                    ❌
                </button>
            </div>
        </SchemaEditContainer>
    </OverlayContainer>

}

